import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unlimitedUsers: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.unlimited-users',
		defaultMessage: 'Unlimited users',
		description: 'Carousel label describing a slide demonstrating unlimited users',
	},
	unlimitedCreators: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.unlimited-creators',
		defaultMessage: 'Unlimited creators',
		description: 'Carousel label describing a slide demonstrating unlimited creators.',
	},
	unlimitedAgents: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.unlimited-agents',
		defaultMessage: 'Unlimited agents',
		description: 'Carousel label describing a slide demonstrating unlimited agents',
	},
	increasedStorageLimits: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.increased-storage-limits',
		defaultMessage: 'Increased storage limits',
		description: 'Carousel label describing a slide demonstrating increased storage limits',
	},
	standardPlanFeatures: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.standard-plan-features',
		defaultMessage: 'Standard plan features',
		description: 'Carousel label describing a slide showing a list of Standard Plan features',
	},
	jsmUserLimitImageAlt: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.jsm-user-limit-image-alt',
		defaultMessage: 'Adding users to Jira Service Management',
		description: 'Alt text for the image of Jira Service Management user limit',
	},
	jsmStorageLimitImageAlt: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.jsm-storage-limit-image-alt',
		defaultMessage: 'Attaching attachments to Jira Service Management',
		description: 'Alt text for the image of Jira Service Management storage limit',
	},
	jswUserLimitImageAlt: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.jsw-user-limit-image-alt',
		defaultMessage: 'Adding users to Jira',
		description: 'Alt text for the image of Jira user limit',
	},
	jswStorageLimitImageAlt: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.jsw-storage-limit-image-alt',
		defaultMessage: 'Attaching attachments to Jira',
		description: 'Alt text for the image of Jira storage limit',
	},
	jpdUserLimitImageAlt: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.jpd-user-limit-image-alt',
		defaultMessage: 'Adding users to Jira Product Discovery',
		description: 'Alt text for the image of Jira Product Discovery user limit',
	},
	jpdStorageLimitImageAlt: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.jpd-storage-limit-image-alt',
		defaultMessage: 'Attaching attachments to Jira Product Discovery',
		description: 'Alt text for the image of Jira Product Discovery storage limit',
	},
});
